import moment from 'moment';

import { COMPLETE_DATE_FORMAT } from '../../../constants';

const safeValue = value =>
  value.split('').includes('(')
    ? value
    : ['(', ...value.split(''), ')'].join('');

export const makeListData = input =>
  input.map(i => ({
    id: i.id,
    left: `${i.componentResultValue || ''} ${i.componentResultUnits || ''}`,
    leftSuffix: `${
      i.componentAbnormalStatus ? safeValue(i.componentAbnormalStatus) : ''
    }`,
    right: moment(i.specimenCollectionDate).format(COMPLETE_DATE_FORMAT),
  }));



// WEBPACK FOOTER //
// ./src/components/PatientHealthboard/PatientPortal/LabTestHistoryModal/utils/list.js